﻿/*
 * Globalize Culture da-DK
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("da-DK", "default", {
    name: "da-DK",
    englishName: "Danish (Denmark)",
    nativeName: "dansk (Danmark)",
    language: "da",
    numberFormat: {
      ",": ".",
      ".": ",",
      negativeInfinity: "-INF",
      positiveInfinity: "INF",
      percent: {
        ",": ".",
        ".": ","
      },
      currency: {
        pattern: ["$ -n", "$ n"],
        ",": ".",
        ".": ",",
        symbol: "kr."
      }
    },
    calendars: {
      standard: {
        "/": "-",
        firstDay: 1,
        days: {
          names: [
            "søndag",
            "mandag",
            "tirsdag",
            "onsdag",
            "torsdag",
            "fredag",
            "lørdag"
          ],
          namesAbbr: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
          namesShort: ["sø", "ma", "ti", "on", "to", "fr", "lø"]
        },
        months: {
          names: [
            "januar",
            "februar",
            "marts",
            "april",
            "maj",
            "juni",
            "juli",
            "august",
            "september",
            "oktober",
            "november",
            "december",
            ""
          ],
          namesAbbr: [
            "jan",
            "feb",
            "mar",
            "apr",
            "maj",
            "jun",
            "jul",
            "aug",
            "sep",
            "okt",
            "nov",
            "dec",
            ""
          ]
        },
        AM: null,
        PM: null,
        patterns: {
          d: "dd-MM-yyyy",
          D: "d. MMMM yyyy",
          t: "HH:mm",
          T: "HH:mm:ss",
          f: "d. MMMM yyyy HH:mm",
          F: "d. MMMM yyyy HH:mm:ss",
          M: "d. MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    // For localized strings
    messages: {
      AdditionalHelp: "Yderligere hjælp",
      AddNewTab: "Tilføj ny fane",
      Alerts: "Advarsler",
      ApplyFilter: "Anvend filter",
      Approve: "Godkend",
      Attachments: "Vedhæftede filer",
      Back: "Tilbage",
      Basic: "Grundlæggende",
      Between: "Mellem",
      Book: "Bog",
      Cancel: "Annuller",
      Checked: "Kontrolleret",
      ClearFilter: "Ryd filter",
      Close: "Luk",
      CloseCancelChanges: "Luk og annuller ændringer",
      CloseSaveChanges: "Luk og gem ændringer",
      CloseTab: "Luk fanen",
      ColumnPersonalization: "Brugertilpasning af kolonne",
      Comments: "Kommentarer",
      Confirmation: "Bekræftelse",
      Contains: "Indeholder",
      CreateTab: "Opret en ny fane",
      Cut: "Klip",
      Delete: "Slet",
      DiscardUndo: "Kassér/Fortryd",
      DisplayDropDownList: "Vis rulleliste",
      Displaying: "Viser: ",
      DocWord: "Dokument",
      DoesNotContain: "Indeholder ikke",
      DoesNotEndWith: "Slutter ikke med",
      DoesNotEqual: "Ikke lig med",
      DoesNotStartWith: "Starter ikke med",
      Download: "Hent",
      Duplicate: "Dupliker",
      Edit: "Rediger",
      EitherSelectedorNotSelected: "Enten valgt eller ikke valgt",
      Email: "E-mail",
      EndsWith: "Slutter med",
      EqualsStr: "Lig med",
      ExpandCollapse: "Udvid/Skjul",
      ExportFailed: "Eksporten mislykkedes",
      ExportToExcel: "Eksporter til Excel",
      FileInUse: "Den angivne fil anvendes i øjeblikket",
      FileInUseDetail:
        "Luk filen i det program, hvor den anvendes, eller angiv et andet filnavn.",
      Filter: "Filter",
      FilterMenu: "Menuen Filter",
      FilterOptions: "Filterindstillinger",
      FilterWithinResults: "Filtrer resultaterne",
      First: "Første",
      FirstView: "Første visning",
      Folder: "Mappe",
      ForgotPassword: "Har du glemt din adgangskode?",
      Forward: "Frem",
      GetMoreRows: "Hent flere rækker",
      GreaterThan: "Større end",
      GreaterThanOrEquals: "Større end eller lig med",
      GridSettings: "Gitterindstillinger",
      GroupSelection: "Valg af gruppe",
      Help: "Hjælp",
      HideColumn: "Skjul kolonne",
      IsEmpty: "Er tom",
      IsNotEmpty: "Er ikke tom",
      Last: "Sidste",
      LastView: "Sidste visning",
      LaunchActivate: "Start/Aktiver",
      LessThan: "Mindre end",
      LessThanOrEquals: "Mindre end eller lig med",
      Links: "Links",
      ListTabs: "Vis alle faner",
      LoadingItem: "Indlæser element ",
      Maintenance: "Vedligeholdelse",
      Menu: "Menu",
      New: "Ny",
      Next: "Næste",
      NextView: "Næste visning",
      No: "Nej",
      NotChecked: "Ikke kontrolleret",
      Notes: "Noter",
      NotSelected: "Ikke valgt",
      Of: " af ",
      Ok: "OK",
      Open: "Åbn",
      Password: "Adgangskode",
      Paste: "Sæt ind",
      Phone: "Telefon",
      PleaseWait: "Vent",
      Previous: "Forrige",
      PreviousView: "Forrige visning",
      Print: "Udskriv",
      Queries: "Forespørgsler",
      Redo: "Annuller fortryd",
      Refresh: "Opdater",
      Reject: "Afvis",
      RememberMe: "Husk mig på denne computer",
      Reports: "Rapporter",
      Reset: "Nulstil",
      Review: "Gennemgå",
      RunFilter: "Kør filter",
      RunJob: "Kør job",
      Save: "Gem",
      SaveBeforeClosing: "Gem før lukning",
      SavedFilters: "Gemte filtre",
      SaveSubmit: "Gem/Send",
      ScreenDesign: "Skærmdesign",
      Search: "Søg",
      SelectContents: "Vælg indhold",
      SelectDate: "Vælg en dato",
      SelectDeselect: "Vælg/Fravælg alt",
      Selected: "Valgt: ",
      ServerName: "Servernavn",
      Settings: "Indstillinger",
      ShowFilterRow: "Vis filterrække",
      SignIn: "Log på",
      SortAscending: "Sorter stigende",
      SortDescending: "Sorter faldende",
      Spreadsheet: "Regneark",
      StartsWith: "Starter med",
      StatusIndicator: "Statusindikator",
      Tasks: "Opgaver",
      Today: "I dag",
      Translate: "Oversæt",
      UserID: "Bruger-id",
      Utilities: "Hjælpeprogrammer",
      Yes: "Ja",
      Page: "Side",
      Rows: "Rækker",
      ShowingAll: "Viser alt",
      SessionNavigation: "Sessionsnavigation",
      ListAllMenuItems: "Vis alle menupunkter",
      NoRecordsFound: "Der blev ikke fundet nogen poster",
      SearchTree: "Søg i træ",
      Clear: "Ryd",
      DrillDown: "Analyser ned",
      Required: "Dette felt er obligatorisk",
      Available: "Tilgængelig:",
      Add: "Tilføj",
      MoveDown: "Flyt ned",
      MoveUp: "Flyt op",
      Remove: "Fjern",
      LastYear: "Sidste år",
      NextMonth: "Næste måned",
      NextWeek: "Næste uge",
      NextYear: "Næste år",
      OneMonthAgo: "En måned siden",
      OneWeekAgo: "En uge siden",
      SixMonthsAgo: "Seks måneder siden",
      Time: "Tid",
      CannotBeSelected: "Denne række kan ikke vælges.",
      ResetToDefault: "Gendan standardlayout",
      CloseOtherTabs: "Luk andre faner",
      EmailValidation: "Indtast en gyldig e-mailadresse",
      UrlValidation: "Indtast en gyldig webadresse",
      EndofResults: "Slut på resultater",
      More: "Mere...",
      RecordsPerPage: "Poster pr. side",
      Maximize: "Maksimer",
      Minimize: "Minimer"
    }
  });
})(this);
